import { Component, OnInit } from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { Helper } from '../../../helpers/helper';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { LowerCasePipe, DecimalPipe } from '@angular/common';
import { ReportesService } from '../../../services/reportes.service';
import { ExcelTitle, ExcelColumns } from '../../../interfaces/excel.interface';
import { ExcelService } from '../../../services/excel.service';
import { AlertasModales } from '../../../helpers/alertasModales';
import { CompaniasService } from '../../../services/companias.service';

const ID_PAGINA = 33;

@Component({
  selector: 'app-reporte-semanal-empresas',
  templateUrl: './reporte-semanal-empresas.component.html',
  styleUrls: ['./reporte-semanal-empresas.component.css']
})
export class ReporteSemanalEmpresasComponent implements OnInit {
  loaded = false;
  loading = false;
  exportando = false;
  registros = [];
  empresas = [];
  empresasSeleccionadas = [];
  ciclo = 0;
  semana = 0;
  year = 0;
  configPdf;
  lowerCasePipe = new LowerCasePipe();
  dropdownSettings: any;
  totales = {
    prestado: 0,
    cuota_ant: 0,
    entregado: 0,
    traido: 0,
    cobrado: 0,
    cuota_act: 0,
    v_cuota: 0,
    v_atrasos: 0,
    a_cta: 0,
    anticipos: 0
  };
  constructor(
    private excelService: ExcelService,
    private helper: Helper,
    private reportesService: ReportesService,
    private route: ActivatedRoute,
    private router: Router,
    private empleadoService: EmpleadosServicio,
    private companiasService: CompaniasService,
    private modals: AlertasModales
    ) {
      if (empleadoService.datosEmpleado.tipo_empleado !== 3
        && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA === ID_PAGINA).length) {
        this.router.navigate(['/404']);
      }
      this.initConfigPdf();
    }

  ngOnInit() {
    this.initConfigMultiSelect();
    this.initEmpresas();
    this.initCiclo();
    window.onresize = () => this.initConfigMultiSelect();
  }

  initCiclo() {
    this.companiasService.cargarCicloActual().subscribe(resp => {
      if (resp) {
        this.ciclo = resp.ciclo;
        this.semana = resp.semana;
        this.year = resp.year;
        this.initReporte();

      }
    });
  }

  private initConfigMultiSelect() {

    this.dropdownSettings = {
      singleSelection: false,
      text: 'Seleccionar empresa',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 3,
      searchPlaceholderText: 'Búsqueda'
    };
  }

  private initReporte(): void {
    this.loading = true;
    this.reportesService.obtenerReporteSemanalEmpresas(this.ciclo, this.semana, this.year,
      this.empresasSeleccionadas.map(data => data.id).join())
    .subscribe((res: any) => {
      this.registros = res;
      setTimeout(() => {
        this.loaded = true;
        this.loading = false;
      }, 1);
    }, err => {
      setTimeout(() => {
        this.loaded = true;
        this.loading = false;
      }, 1);
      if (err.status === 400) {
        this.modals.validacionesModalJquery('Advertencia', err.error, 'orange', 'modern');
      }
    });
  }

  filtrar() {
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams['empresas'];
    const empresas = this.empresasSeleccionadas.map(data => data.id).join();
    if (empresas) {
      queryParams['empresas'] = empresas;
    }
    if (!isNaN(this.ciclo)) {
      queryParams['ciclo'] = this.ciclo;
    }
    if (!isNaN(this.semana)) {
      queryParams['semana'] = this.semana;
    }
    if (!isNaN(this.year)) {
      queryParams['year'] = this.year;
    }

    this.router.navigate(['./reporte/semanal-empresas'], { queryParams: queryParams });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        if (params.empresas) {
          this.empresasSeleccionadas = [];
          for (const empresaSeleccionada of params.empresas.split(',')) {
            for (const empresa of this.empresas) {
                if (parseFloat(empresaSeleccionada) === empresa.id) {
                  this.empresasSeleccionadas.push(empresa);
                }
             }
          }
        }
        if (!isNaN(params.ciclo)) {
          this.ciclo = params.ciclo;
        }
        if (!isNaN(params.semana)) {
          this.semana = params.semana;
        }
        if (!isNaN(params.year)) {
          this.year = params.year;
        }

        this.initReporte();
      }
    });
  }

  private initConfigPdf(): void {
    this.reportesService.obtenerConfiguraciones()
    .subscribe((res: any) => {
      this.configPdf = {
        direccion: res.direccion_recibo,
        tel: res.telefono_recibo,
        nombre_compania: res.descripcion,
        rnc_compania: res.rnc,
        fax_compania: res.fax,
        email_compania: res.email,
        ciudad_compania: res.ciudad,
        tel_compania: res.telefono,
        direccion_compania: res.direccion
      };
    });
  }

  initEmpresas() {
    this.empresas = [];
    this.empresasSeleccionadas = [];
    this.companiasService.cargarTodasLasEmpresas().subscribe(res => {
      for (const empresa of res) {
        this.empresas.push({
          id: empresa.id,
          itemName: this.lowerCasePipe.transform(empresa.descripcion)
        });
      }

      this.verificarQueryString();
    });
  }

  exportar() {
    if (!this.exportando && this.registros.length > 0) {
      let title = 'Reporte Consolidado';
      if (!this.empresasSeleccionadas.length) {
        title += ' de todas las empresas';
      } else {
        title += ' empresas (' + this.empresasSeleccionadas.map(item => item.id).join() + ')';
      }

      title +=  ` ciclo ${this.ciclo} semana ${this.semana} año ${this.year}`;
      this.exportando = true;
      const titulo: ExcelTitle = {
        title,
        font: { name: 'Arial', size: 16, underline: 'double', bold: true }
      };
      const columns: ExcelColumns =  {
      // tslint:disable-next-line:max-line-length
      columns: [],
      columnOptions: [
      {key: 1, properties: {width: 20} },
      {key: 2, properties: {width: 10} },
      {key: 3, properties: {width: 12} },
      {key: 4, properties: {width: 10} },
      {key: 5, properties: {width: 10} },
      {key: 6, properties: {width: 10} },
      {key: 7, properties: {width: 10} },
      {key: 8, properties: {width: 10} },
      {key: 9, properties: {width: 10} },
      {key: 10, properties: {width: 10} },
      {key: 11, properties: {width: 10} },
      {key: 12, properties: {width: 10} },
      {key: 13, properties: {width: 10} },
      {key: 14, properties: {width: 10} },
      {key: 15, properties: {width: 10} },
      ]
      };
      const data: any = {
        rows: [],
        cellsOptions: []
      };
      const decimalPipe = new DecimalPipe('en-US');
                // empresas
                const empresas = this.empresasSeleccionadas.map(item => item.id).join();
                // titulo
                data.rows.push(
                  [
                    'Reporte Consolidado',
                    'Ciclo ' + this.ciclo,
                    'Semana ' + this.semana,
                    'Año ' + this.year,
                    empresas.length ? 'Empresas' : '',
                    empresas.length ? empresas : '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    {
                      properties: {
                      fill: {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFFFF' },
                      },
                      font: {
                        color: {argb: '000000'},
                        size: 12,
                        bold: true
                      }
                      }
                    }
                  ]
                );
      for (let i = 0; i < this.registros.length; i++) {


        if (i === 0) {
          data.rows.push(
            [
              'Empresa',
              'Prestado',
              'Cobrado',
              'Efect.',
              'V.Cuota',
              'V.Clientes',
              'Atrasos',
              '% A/C',
              'Cuotas',
              'Clientes',
              'V.Clientes.A',
              'A.A',
              'V.C.A',
              '% AA/CA',
              'Cuota prox.',
              {
                properties: {
                fill: {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: this.helper.colorApp },
                },
                font: {
                  color: {argb: 'FFFFFF'},
                  size: 9
                }
                }
              }
            ]
          );
        // tslint:disable-next-line:max-line-length
        } else if (this.registros[i - 1].empresa_nombre === 'SUB-TOTAL: ' && i + 1 !== this.registros.length) {
          data.rows.push(
            [
              'Empresa',
              'Prestado',
              'Cobrado',
              'Efect.',
              'V.Cuota',
              'V.Clientes',
              'Atrasos',
              '% A/C',
              'Cuotas',
              'Clientes',
              'V.Clientes.A',
              'A.A',
              'V.C.A',
              '% AA/CA',
              'Cuota prox.',
              {
                properties: {
                fill: {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: this.helper.colorApp },
                },
                font: {
                  color: {argb: 'FFFFFF'},
                  size: 9
                }
                }
              }
            ]
          );
        }

        data.rows.push(
          [
            // empresa_nombre
            this.registros[i].empresa_nombre,
            // prestado
            decimalPipe.transform(this.registros[i].prestado, '1.2-2') ,
            // Cobrado
            decimalPipe.transform(this.registros[i].cobrado, '1.2-2'),
            // Efectividad
            decimalPipe.transform(this.registros[i].efectividad, '1.0-0'),
            // V.Cuota
            decimalPipe.transform(this.registros[i].v_cuota, '1.0-0'),
            // V.Clientes
            decimalPipe.transform(this.registros[i].v_clientes, '1.0-0'),
            // Atrasos
            decimalPipe.transform(this.registros[i].variacion_atrasos, '1.0-0'),
            // % A/C
            decimalPipe.transform(this.registros[i].a_cta, '1.2-2'),
            // Cuotas
            decimalPipe.transform(this.registros[i].cuota_anterior, '1.0-0'),
            // Clientes
            decimalPipe.transform(this.registros[i].clientes_anterior , '1.0-0'),
            // Clientes Acumulados
            decimalPipe.transform(this.registros[i].clientes_a , '1.0-0'),
            // A.A
            decimalPipe.transform( this.registros[i].a_a, '1.0-0'),
            // V.C.A
            decimalPipe.transform( this.registros[i].v_c_a, '1.0-0'),
            // % AA/CA
            decimalPipe.transform(this.registros[i].a_a / (this.registros[i].c_a - this.registros[i].cuota_actual) * 100, '1.2-2'),
            // Cuota Proxima.
            decimalPipe.transform( this.registros[i].cuota_actual, '1.0-0'),
            {
              properties: {
              fill: {
                type: 'pattern',
                pattern: 'solid',
                // tslint:disable-next-line:max-line-length
                fgColor: { argb: this.registros[i].empresa_nombre === 'SUB-TOTAL: ' ? '797979' : (this.registros[i].empresa_nombre === 'TOTAL: ' ? '000000' : '') },
              },
              font: {
                // tslint:disable-next-line:max-line-length
                color: { argb: this.registros[i].empresa_nombre === 'SUB-TOTAL: ' || this.registros[i].empresa_nombre === 'TOTAL: ' ? 'FFFFFF' : '000000'},
                size: 9
              },
              border: {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
              }
              }
            }
          ]
        );
      }
      this.excelService.generateExcel(titulo, columns, data).then(() => this.exportando = false);
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/reportes/reporte-semanal-empresas/reporte-semanal-empresas.component.ts